// AdSense Gelir Optimizasyon Konfigürasyonu

export const AD_CONFIG = {
  // Reklam sıklık ayarları
  frequency: {
    newsListInterval: 8, // Haber listesinde kaç haberde bir reklam
    maxAdsPerPage: 3, // Sayfa başına maksimum reklam sayısı
    minContentLength: 4, // İçerik ortası reklam için minimum paragraf sayısı
  },

  // AdSense optimizasyon ayarları
  adsense: {
    minHeight: 280, // AdSense viewability için minimum yükseklik
    lazyLoadThreshold: 200, // Lazy loading için threshold (px)
    scriptTimeout: 100, // Script injection gecikmesi (ms)
    viewabilityCheckDelay: 500, // Viewability check gecikmesi (ms)
  },

  // Pozisyon prioriteleri (gelir potansiyeline göre)
  positionPriority: {
    MIDDLE_CONTENT: 1, // En yüksek gelir
    AFTER_CONTENT: 2,
    ABOVE_TITLE: 3,
    SIDEBAR: 4,
    BELOW_TITLE: 5, // En düşük gelir - sınırlı kullanım
  },

  // AdSense publisher ID'si - ads.txt ile eşleştirildi
  publisherId: 'ca-pub-9508707829262825', // Gerçek AdSense ID'si

  // Responsive reklam ayarları
  responsive: {
    mobile: {
      maxWidth: '100%',
      preferredFormats: ['auto', 'rectangle', 'banner'],
    },
    desktop: {
      maxWidth: '728px',
      preferredFormats: ['auto', 'leaderboard', 'rectangle'],
    },
  },

  // Gelir optimizasyon kuralları
  optimization: {
    // Kullanıcı deneyimini korumak için minimum mesafeler
    minAdSpacing: 300, // Reklamlar arası minimum mesafe (px)
    
    // Viewability optimizasyonu
    viewabilityThreshold: 0.5, // Reklamın %50'si görünür olmalı
    
    // Loading optimizasyonu
    enableLazyLoading: true, // Lazy loading aktif
    preloadThreshold: 100, // Pre-load threshold (px)
  },

  // Hata yönetimi
  errorHandling: {
    maxRetries: 3, // Maksimum tekrar deneme sayısı
    fallbackEnabled: true, // Fallback reklam sistemi
    timeout: 5000, // Reklam yükleme timeout (ms)
  },
};

// AdSense script'i kontrolü
export const isAdSenseLoaded = (): boolean => {
  return typeof window !== 'undefined' && !!window.adsbygoogle;
};

// Viewability hesaplaması
export const calculateViewability = (element: HTMLElement): number => {
  if (!element) return 0;
  
  const rect = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;
  
  const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
  const visibleWidth = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0);
  
  if (visibleHeight <= 0 || visibleWidth <= 0) return 0;
  
  const visibleArea = visibleHeight * visibleWidth;
  const totalArea = rect.height * rect.width;
  
  return totalArea > 0 ? visibleArea / totalArea : 0;
};

// Gelir optimizasyonu için reklam pozisyon skoru
export const getAdPositionScore = (position: string): number => {
  return AD_CONFIG.positionPriority[position as keyof typeof AD_CONFIG.positionPriority] || 99;
};

export default AD_CONFIG; 